<script>
import Vue from "vue"
import isTouchDevice from "is-touch-device";
import isMobile from "ismobilejs";
import { ContentLoader } from "vue-content-loader";
import {getPosts, getTerms, getLexicon} from "../rest-service/rest-service";
import AsyncComputed from "vue-async-computed";
import Multiselect from "vue-multiselect";
Vue.use(AsyncComputed)
import VIcon from "../VIcon/vue-icon.vue"
import {baseUrl} from '../static-vars/static-vars'
import nl2br from "nl2br"
import MacroTitle from '../MacroTitle/MacroTitle.vue';
const slugify = require('slugify')

export default {
  name: "VMixins",
  data () {
    return {

    }
  },

  components: {
    Multiselect,
    ContentLoader,
    MacroTitle,
    VIcon
  },

  computed: {
    lang () {
      return document.documentElement.lang.split('-')[0]
    },

    baseUrl () {
      return baseUrl
    },

    isMobileAndTouch () {
      return isTouchDevice() && isMobile(navigator.userAgent).any
    },
  },

  methods: {
    customNl2Br (text) {
      return nl2br(text)
    },

    sortAlphabetically (array, key) {
      return array.sort((a, b) => a[key].localeCompare(b[key]))
    },

    formSubmitHandler (evt) {
      evt.preventDefault();
    },

    /**
     * @function convertToCurrency
     * @param {Number} price
     * @param {Boolean} hideCurrency
     * @description convert a price to currency format with decimals replacement
     * @return {String}
     **/
    convertToCurrency (price, hideCurrency = false) {
      try {
        let value = new Intl.NumberFormat('de-CH',
            { style: 'currency', currency: 'CHF' }
        ).format(price).replace('.00', '.—')

        value = !hideCurrency ? value : value.replace(/&nbsp;/g, '').replace('CHF', '')

        return price ? value : '';
      } catch (e) {
        return '';
      }
    },

    showMore () {
      this.page++
    },

    displayDatesRange (dateStart, dateEnd) {
      let output = '';
      try {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const dateStartObject = new Date(dateStart);
        const dateEndObject = new Date(dateEnd);

        if (dateStart && !dateEnd) {
          output = `${new Date(dateStartObject).toLocaleDateString('de-DE', options)}`
        }
        else if (dateStart === dateEnd) {
          output = `${new Date(dateStartObject).toLocaleDateString('de-DE', options)}`
        } else {
          if (dateStartObject.getFullYear() === dateEndObject.getFullYear()) {
            output = `${new Date(dateStartObject).toLocaleDateString('de-DE', {day: '2-digit'})}.${new Date(dateStartObject).toLocaleDateString('de-DE', {month: '2-digit'})}. -<br>`
            output += `${new Date(dateEndObject).toLocaleDateString('de-DE', options)}`
          } else {
            output = `${new Date(dateStartObject).toLocaleDateString('de-DE', options)}<br>`
            output += `${new Date(dateEndObject).toLocaleDateString('de-DE', options)}`
          }
        }
      } catch (e) {
        console.error(e);
      }

      return output
    },

    formatPhoneNumber (text) {
      try {
        const phoneRegex = /(\+[0-9]{2})-?([0-9]{2})([0-9]{3})([0-9]{2})([0-9]{2})/
        const phoneRegexResult = phoneRegex.exec(text).splice(1, 5);
        return phoneRegexResult.join(" ")
      } catch (e) {
        return text;
      }
    },

    sortByDate(array, key) {
      return array.sort((a, b) => new Date(a[key]).getTime() - new Date(b[key]).getTime())
    },

    toSLug(text) {
      try {
        return slugify(text, {
          lower: true,
          strict: true,
        })
      } catch (e) {
        return '';
      }
    }
  }
}
</script>
